(() => {
  if (customElements.get('st-subscription-only')) return;

  class StSubscriptionOnly extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.form = this.querySelector('[data-st-subscription-only-form]');
      this.submitButton = this.querySelector('[data-st-subscription-only-submit]');
      this.submitLabel = this.querySelector('[data-st-subscription-only-submit-label]');
      this.errorMessage = this.querySelector('[data-st-subscription-only-error]');
      this.choices = this.querySelector('fieldset');
      this.pending = false;

      this.form.addEventListener('change', () => this.updateSelection(), options);
      this.form.addEventListener('submit', (event) => this.addSubscription(event), options);
      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-st-subscription-only-image-target]');
        if (thumbnail && this.contains(thumbnail)) this.showImage(thumbnail);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const thumbnail = event.target.closest('[data-st-subscription-only-image-target]');
        if (thumbnail) this.showImage(thumbnail);
      }, options);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.resetSubmission();
      }, options);
      this.updateSelection();
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    showImage(thumbnail) {
      this.querySelectorAll('[data-st-subscription-only-image]').forEach((image) => {
        image.hidden = image.id !== thumbnail.dataset.stSubscriptionOnlyImageTarget;
      });
      this.querySelectorAll('[data-st-subscription-only-image-target]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === thumbnail));
      });
    }

    getSelection() {
      const selected = this.form.querySelector('input[name="selling_plan"]:checked');
      if (!selected || !/^\d+$/.test(selected.value) || !/^\d+$/.test(selected.dataset.variantId)) return null;
      return { id: selected.dataset.variantId, quantity: 1, selling_plan: selected.value };
    }

    updateSelection() {
      this.submitButton.disabled = this.pending || this.dataset.designMode === 'true' || !this.getSelection();
      this.errorMessage.hidden = true;
    }

    resetSubmission() {
      this.pending = false;
      this.choices.disabled = false;
      this.submitButton.removeAttribute('aria-busy');
      this.submitLabel.textContent = 'Continue to checkout';
      this.updateSelection();
    }

    async addSubscription(event) {
      event.preventDefault();
      const selection = this.getSelection();
      if (this.pending || this.dataset.designMode === 'true' || !selection) return;

      this.pending = true;
      this.submitButton.disabled = true;
      this.choices.disabled = true;
      this.submitButton.setAttribute('aria-busy', 'true');
      this.submitLabel.textContent = 'Adding subscription…';
      this.errorMessage.hidden = true;

      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [selection] })
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || result?.status >= 400 || !Array.isArray(result?.items) || result.items.length === 0) {
          const detail = result?.description;
          throw new Error(typeof detail === 'string' ? detail : 'Unable to add your subscription. Please try again.');
        }
        if (this.isConnected) window.location.assign(this.dataset.checkoutUrl);
      } catch (error) {
        if (!this.isConnected) return;
        this.resetSubmission();
        this.errorMessage.textContent = error.message || 'Unable to add your subscription. Please try again.';
        this.errorMessage.hidden = false;
        this.errorMessage.focus();
      }
    }
  }

  customElements.define('st-subscription-only', StSubscriptionOnly);
})();
